import { Instagram, Mail } from "lucide-react";
import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";
import { MAILTO_URL, INSTAGRAM_URL } from "@/constants/links";

export default function ContactCta() {
    return (
        <section id="iletisim" data-testid="final-cta-section" className="scroll-mt-24 py-24 md:py-36">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <Reveal>
                    <Eyebrow>İletişim</Eyebrow>
                    <h2 className="mt-5 max-w-3xl font-display text-4xl leading-[1.05] text-cream sm:text-6xl lg:text-7xl">
                        Markanızın hikâyesini konuşalım.
                    </h2>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-fog md:text-lg">
                        İşletmeniz için nasıl bir içerik sistemi kurabileceğimizi
                        birlikte planlayalım.
                    </p>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="mt-12 flex flex-col gap-3 sm:flex-row sm:gap-4">
                        <a
                            href={MAILTO_URL}
                            data-testid="cta-email-button"
                            className="inline-flex items-center justify-center gap-3 bg-cream px-8 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-ink transition-colors hover:bg-white"
                        >
                            <Mail className="h-5 w-5" />
                            Bize Yaz
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="cta-instagram-button"
                            className="inline-flex items-center justify-center gap-3 border border-cream/40 px-8 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-cream transition-colors hover:border-cream hover:bg-cream/5"
                        >
                            <Instagram className="h-5 w-5" />
                            Instagram'da Bizi Gör
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
